const DaArray = [
  {
    id: 1,
    Img: "./data-img/01.jpg",
    name: "Rainbow Vegetable Sandwich",
    time: "15 - 20",
    price: "$10.50",
  },
  {
    id: 2,
    Img: "./data-img/02.jpg",
    name: "Vegetarian Burger",
    time: "30 - 45",
    price: "$9.20",
  },
  {
    id: 3,
    Img: "./data-img/03.jpg",
    name: "Raspberry Stuffed French Toast",
    time: "10 - 15",
    price: "$12.50",
  },
  {
    id: 4,
    Img: "./data-img/02.jpg",
    name: "Vegetarian Burger",
    time: "30 - 45",
    price: "$9.20",
  },
  {
    id: 5,
    Img: "./data-img/03.jpg",
    name: "Raspberry Stuffed French Toast",
    time: "10 - 15",
    price: "$12.50",
  },
];

export default DaArray;
